import { EffectSelectionOptions, } from './effect-selection-constants.js';
// Common multi-select employee selection step
export const createMultiSelectEmployeeSelectionStep = (stepId, nextStepId) => ({
    id: stepId,
    title: 'wizard:questions.praiseFeedbackEmployeeSelection.title',
    component: {
        id: 'MultiEmployeeSelection',
        props: {
            options: {
                type: 'fetch',
                data: 'fetch-employees',
            },
            columns: {
                type: 'static',
                data: 2,
            },
            placeholder: {
                type: 'static',
                data: 'wizard:questions.praiseFeedbackEmployeeSelection.placeholder',
            },
            multiSelect: {
                type: 'static',
                data: true,
            },
        },
    },
    nextStep: nextStepId,
    validation: (answer) => {
        if (!answer || (Array.isArray(answer) && answer.length === 0))
            return 'wizard:questions.praiseFeedbackEmployeeSelection.validation';
        return null;
    },
});
// Common recipient selection step (me vs other employees)
export const createRecipientSelectionStep = (stepId, nextStepIdForEmployees, nextStepIdForMe, titleKey) => ({
    id: stepId,
    title: titleKey,
    component: {
        id: 'ChoiceList',
        props: {
            options: {
                type: 'static',
                data: [
                    {
                        id: 'employees',
                        title: 'wizard:questions.praiseFeedbackRecipient.options.employees.title',
                        description: 'wizard:questions.praiseFeedbackRecipient.options.employees.description',
                        icon: '👥',
                    },
                    {
                        id: 'me',
                        title: 'wizard:questions.praiseFeedbackRecipient.options.me.title',
                        description: 'wizard:questions.praiseFeedbackRecipient.options.me.description',
                        icon: '✨',
                    },
                ],
            },
            columns: {
                type: 'static',
                data: 2,
            },
            variant: {
                type: 'static',
                data: 'card',
            },
        },
    },
    nextStep: (answer) => {
        if (answer[0] === 'employees')
            return nextStepIdForEmployees;
        if (answer[0] === 'me')
            return nextStepIdForMe;
        return nextStepIdForMe; // default fallback
    },
    validation: (answer) => {
        if (!answer)
            return 'wizard:questions.praiseFeedbackRecipient.validation';
        return null;
    },
});
// Common framework selection step that can be used in both praise and feedback wizards
export const createFrameworkSelectionStep = (stepId, nextStepId, wizardType) => ({
    id: stepId,
    title: `wizard:${wizardType}Questions.frameworkSelection.title`,
    component: {
        id: 'ChoiceList',
        props: {
            options: {
                type: 'static',
                data: [
                    {
                        id: 'one-on-one',
                        title: 'wizard:questions.frameworkSelection.options.oneOnOne.title',
                        icon: '👥',
                    },
                    {
                        id: 'meeting',
                        title: 'wizard:questions.frameworkSelection.options.meeting.title',
                        icon: '🏢',
                    },
                    {
                        id: 'casual-conversation',
                        title: 'wizard:questions.frameworkSelection.options.casualConversation.title',
                        icon: '💬',
                    },
                    {
                        id: 'phone-call',
                        title: 'wizard:questions.frameworkSelection.options.phoneCall.title',
                        icon: '📞',
                    },
                    {
                        id: 'email',
                        title: 'wizard:questions.frameworkSelection.options.email.title',
                        icon: '📧',
                    },
                    {
                        id: 'instant-message',
                        title: 'wizard:questions.frameworkSelection.options.instantMessage.title',
                        icon: '💬',
                    },
                    {
                        id: 'social-media',
                        title: 'wizard:questions.frameworkSelection.options.socialMedia.title',
                        icon: '📱',
                    },
                    {
                        id: 'solve-platform',
                        title: 'wizard:questions.frameworkSelection.options.solvePlatform.title',
                        icon: '🚀',
                    },
                    {
                        id: 'another-way',
                        title: 'wizard:questions.frameworkSelection.options.other.title',
                        icon: '💡',
                    },
                    {
                        id: 'not-relevant',
                        title: 'wizard:questions.frameworkSelection.options.notRelevant.title',
                        icon: '❌',
                    },
                ],
            },
            columns: { type: 'static', data: 2 },
            variant: { type: 'static', data: 'card' },
        },
    },
    nextStep: nextStepId,
    validation: (answer) => {
        if (!answer)
            return `wizard:${wizardType}Questions.frameworkSelection.validation`;
        return null;
    },
});
export const createBodyLanguageFrameworkSelectionStep = (nextStepId) => ({
    id: 'body-language-framework-selection',
    title: 'wizard:questions.bodyLanguageFrameworkSelection.title',
    component: {
        id: 'ChoiceList',
        props: {
            options: {
                type: 'static',
                data: [
                    {
                        id: 'one-on-one',
                        title: 'wizard:questions.frameworkSelection.options.oneOnOne.title',
                        icon: '👥',
                    },
                    {
                        id: 'meeting',
                        title: 'wizard:questions.frameworkSelection.options.meeting.title',
                        icon: '🏢',
                    },
                    {
                        id: 'casual-conversation',
                        title: 'wizard:questions.frameworkSelection.options.casualConversation.title',
                        icon: '💬',
                    },
                    {
                        id: 'another-way',
                        title: 'wizard:questions.frameworkSelection.options.other.title',
                        icon: '💡',
                    },
                ],
            },
        },
    },
    nextStep: nextStepId,
    validation: (answer) => {
        if (!answer || (Array.isArray(answer) && answer.length === 0))
            return 'wizard:questions.bodyLanguageFrameworkSelection.validation';
        return null;
    },
});
export const createWrittenMessagesSelectionStep = (nextStepId) => ({
    id: 'written-communication-framework-selection',
    title: 'wizard:questions.writtenCommunicationFrameworkSelection.title',
    component: {
        id: 'ChoiceList',
        props: {
            options: {
                type: 'static',
                data: [
                    {
                        id: 'email',
                        title: 'wizard:questions.frameworkSelection.options.email.title',
                        icon: '📧',
                    },
                    {
                        id: 'instant-message',
                        title: 'wizard:questions.frameworkSelection.options.instantMessage.title',
                        icon: '💬',
                    },
                    {
                        id: 'social-media',
                        title: 'wizard:questions.frameworkSelection.options.socialMedia.title',
                        icon: '📱',
                    },
                    {
                        id: 'solve-platform',
                        title: 'wizard:questions.frameworkSelection.options.solvePlatform.title',
                        icon: '🔧',
                    },
                    {
                        id: 'other-written',
                        title: 'wizard:questions.frameworkSelection.options.other.title',
                        icon: '❓',
                    },
                ],
            },
            columns: {
                type: 'static',
                data: 2,
            },
        },
    },
    nextStep: nextStepId,
    validation: (answer) => {
        if (!answer || (Array.isArray(answer) && answer.length === 0))
            return 'wizard:feedbackQuestions.writtenCommunicationFrameworkSelection.validation';
        return null;
    },
});
export const createVerbalExpressionsSelectionStep = (nextStepId) => ({
    id: 'verbal-expressions-framework-selection',
    title: 'wizard:questions.verbalExpressionsFrameworkSelection.title',
    component: {
        id: 'ChoiceList',
        props: {
            options: {
                type: 'static',
                data: [
                    {
                        id: 'one-on-one',
                        title: 'wizard:questions.frameworkSelection.options.oneOnOne.title',
                        icon: '👥',
                    },
                    {
                        id: 'meeting',
                        title: 'wizard:questions.frameworkSelection.options.meeting.title',
                        icon: '🏢',
                    },
                    {
                        id: 'casual-conversation',
                        title: 'wizard:questions.frameworkSelection.options.casualConversation.title',
                        icon: '💬',
                    },
                    {
                        id: 'phone-call',
                        title: 'wizard:questions.frameworkSelection.options.phoneCall.title',
                        icon: '📞',
                    },
                    {
                        id: 'another-way',
                        title: 'wizard:questions.frameworkSelection.options.other.title',
                        icon: '💡',
                    },
                ],
            },
        },
    },
    nextStep: nextStepId,
    validation: (answer) => {
        if (!answer || (Array.isArray(answer) && answer.length === 0))
            return 'wizard:questions.verbalExpressionsSelection.validation';
        return null;
    },
});
export const createAdditionalEffectsSelectionStep = (wizardType) => ({
    id: 'additional-effects',
    title: `wizard:${wizardType}Questions.additionalEffects.title`,
    component: {
        id: 'ChoiceList',
        props: {
            options: {
                type: 'static',
                data: [
                    {
                        id: EffectSelectionOptions.ENERGY,
                        title: `wizard:${wizardType}Questions.additionalEffects.options.${EffectSelectionOptions.ENERGY}.title`,
                        icon: '⚡',
                    },
                    {
                        id: EffectSelectionOptions.CONFIDENCE,
                        title: `wizard:${wizardType}Questions.additionalEffects.options.${EffectSelectionOptions.CONFIDENCE}.title`,
                        icon: '👍',
                    },
                    {
                        id: EffectSelectionOptions.CONNECTION,
                        title: `wizard:${wizardType}Questions.additionalEffects.options.${EffectSelectionOptions.CONNECTION}.title`,
                        icon: '❤️',
                    },
                    {
                        id: EffectSelectionOptions.REPUTATION,
                        title: `wizard:${wizardType}Questions.additionalEffects.options.${EffectSelectionOptions.REPUTATION}.title`,
                        icon: '🏆',
                    },
                    {
                        id: EffectSelectionOptions.MEANINGFUL,
                        title: `wizard:${wizardType}Questions.additionalEffects.options.${EffectSelectionOptions.MEANINGFUL}.title`,
                        icon: '🎯',
                    },
                    {
                        id: EffectSelectionOptions.BELONGING,
                        title: `wizard:${wizardType}Questions.additionalEffects.options.${EffectSelectionOptions.BELONGING}.title`,
                        icon: '👥',
                    },
                    {
                        id: EffectSelectionOptions.RESPONSIBILITY,
                        title: `wizard:${wizardType}Questions.additionalEffects.options.${EffectSelectionOptions.RESPONSIBILITY}.title`,
                        icon: '✅',
                    },
                    {
                        id: EffectSelectionOptions.LEARNING,
                        title: `wizard:${wizardType}Questions.additionalEffects.options.${EffectSelectionOptions.LEARNING}.title`,
                        icon: '🧠',
                    },
                    {
                        id: EffectSelectionOptions.NO_OTHER_EFFECTS,
                        title: `wizard:${wizardType}Questions.additionalEffects.options.${EffectSelectionOptions.NO_OTHER_EFFECTS}.title`,
                        icon: '❌',
                        exclusive: true,
                    },
                ],
            },
            columns: {
                type: 'static',
                data: 3,
            },
            multiSelect: {
                type: 'static',
                data: true,
            },
            maxItems: {
                type: 'static',
                data: 3,
            },
        },
    },
    nextStep: (answer) => {
        // Check if any of the selected options require follow-up questions
        const answers = answer;
        if (Array.isArray(answer)) {
            const followUpOptions = [
                EffectSelectionOptions.ENERGY,
                EffectSelectionOptions.CONFIDENCE,
                EffectSelectionOptions.REPUTATION,
                EffectSelectionOptions.BELONGING,
                EffectSelectionOptions.RESPONSIBILITY,
            ];
            const hasFollowUp = answers.some((effect) => followUpOptions.includes(effect));
            if (hasFollowUp) {
                return 'additional-effects-details';
            }
        }
        // If none of the follow-up options were selected, go to company values
        return 'company-values';
    },
    validation: (answer) => {
        if (!answer || (Array.isArray(answer) && answer.length === 0)) {
            return `wizard:${wizardType}Questions.additionalEffectsDetails.validation`;
        }
        return null;
    },
});
